import CurrentUserMenu from 'components/layout/current-user-menu'
import UserAvatar from 'components/utilities/user-avatar'
import { useCurrentUser } from 'context/current-user-context'
import classNames from 'helpers/class-names'
import { FC } from 'react'
import { Menu } from 'ui'

interface Props {
  className?: string
}

const CurrentUserAvatar: FC<Props> = ({ className = '' }) => {
  const { email, uuid } = useCurrentUser()

  const UserButton = () => (
    <div className="h-10 w-10 overflow-hidden rounded-full border-2 border-gray-400 focus:outline-none group-focus-visible:border-info/75 dark:border-gray-500">
      {email && <UserAvatar email={email} className="h-full w-full" />}
    </div>
  )

  if (!uuid) {
    return null
  }

  return (
    <Menu
      className="mr-px pr-2.5"
      buttonClass={classNames('focus-visible:ring-0 group', className)}
      trigger={UserButton}
      offset={[16, 10]}>
      <CurrentUserMenu />
    </Menu>
  )
}

export default CurrentUserAvatar
